import { toast } from 'react-toastify'
import {
  getAllIncidents,
  getAllIncidentsInvitedUsers,
  getAllSchoolMembers,
  getIncidentById,
} from '../../../../api/lead/incidents'
import {
  incidentDataCountObj,
  incidentDataResponse,
  incidentDataResponseObject,
  invitedUsers,
  invitedUsersResponse,
  schoolMembers,
  schoolMembersResponse,
} from '../../../../utils/types'

export const getIncidentData = async (
  currentPage: number,
  sortBy: string,
  sortOrderValue: string
): Promise<incidentDataCountObj> => {
  const response = (await getAllIncidents(
    // currentPage,
    sortBy,
    sortOrderValue
  )) as incidentDataResponse
  if (response?.status != 'successful') {
    toast.error('Network Error.', {
      position: 'top-right',
    })
  }
  return response?.data
}

export const getIncidentDataById = async (
  id: string,
  sId: string
): Promise<incidentDataResponseObject> => {
  const response = (await getIncidentById(
    id,
    sId
  )) as incidentDataResponseObject

  if (response?.status != 'successful') {
    toast.error('Network Error.', {
      position: 'top-right',
    })
  }
  return response
}
export const getAllCandidates = async (): Promise<schoolMembers[]> => {
  const response = (await getAllSchoolMembers()) as schoolMembersResponse

  if (response?.status != 'successful') {
    toast.error('Network Error.', {
      position: 'top-right',
    })
  }
  return response?.data
}

export const getAllUsersInvited = async (
  id: string
): Promise<invitedUsers[]> => {
  const response = (await getAllIncidentsInvitedUsers(
    id
  )) as invitedUsersResponse

  if (response?.status != 'successful') {
    toast.error('Network Error.', {
      position: 'top-right',
    })
  }
  return response?.data
}
